import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(245, 158, 11, 0)', '0px 0px 25px rgba(245, 158, 11, 0.4)', '0px 0px 0px rgba(245, 158, 11, 0)']
  }} transition={{
    duration: 2.5,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`relative w-full sm:w-auto bg-gradient-to-r from-amber-500 to-amber-400 text-navy-900 font-bold text-lg sm:text-xl py-4 px-8 rounded-xl shadow-lg hover:from-amber-400 hover:to-amber-300 transition-all duration-300 ${className}`} data-id="element-14">
      {text}
    </motion.button>;
}